/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize ProfilesCreation View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './profilesViewEdit';

/**
 * Map state to props
 * @returns { object }
 */
export const mapStateToPropsProfileViewEdit = mapStateToProps;
export const mapDispatchToPropsProfileViewEdit = mapDispatchToProps;

export default connect(
  mapStateToPropsProfileViewEdit,
  mapDispatchToPropsProfileViewEdit
)(View);
